export const nameFromEmail = (
  email: unknown,
  defaultName = 'User',
  requireFirstLast = false,
): string => {
  if (typeof email !== 'string') return defaultName;
  const localPart = email.trim().split('@')[0].replace(/\d/g, '');
  if (requireFirstLast && !/^[a-z]+(?:[-'][a-z]+)*\.[a-z]+(?:[-'][a-z]+)*$/i.test(localPart)) {
    return defaultName;
  }
  const name = localPart
    .replace(/\./g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1).toLowerCase()}`)
    .join(' ');
  return name || defaultName;
};
